<template>
  <mdc-select-field
    :value="value"
    label="Currency"
    name="currency"
    id-key="code"
    value-key="code"
    label-key="code"
    :options="currencySymbols"
    @input="onChange"
  />
</template>
<script>
import MdcSelectField from '../material/SelectField'
import ALLOWED_CURRENCIES from './AllowedCurrencies'
import * as CURRENCY_SYMBOL_MAP from 'currency-symbol-map/map'

const currencySymbols = Object.keys(CURRENCY_SYMBOL_MAP).map(code => ({
  code,
  symbol: CURRENCY_SYMBOL_MAP[code]
})).filter(c => ALLOWED_CURRENCIES.includes(c.code))

export default {
  components: {
    MdcSelectField
  },
  props: {
    value: {
      type: String,
      default: 'USD'
    }
  },
  data () {
    return {
      currencySymbols
    }
  },
  methods: {
    onChange (e) {
      this.$emit('input', e)
    }
  }

}
</script>
